"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uuidjs_1 = __importDefault(require("uuidjs"));
// 企微sdk注册
var jssdk_http_1 = require("./ajax/jssdk-http");
var $uuid = function () { return uuidjs_1.default.generate(); };
// 需求文档：https://doc.weixin.qq.com/doc/w3_ABQABwZCADkeG0iqHVuR9Opk5kDax?scode=ACUArAcBAAk09SL7SpACMAJgZoAAs
/**
 * 1. 一级事件：停留时长上报
 * 1.1 生成唯一的activityId，该activityId会作为其他事件的parentActivityId
 * 1.2 parentActivityId：使用时传入，只有小程序中访问营销素材场景
 */
/**
 * 2. 其他事件(员工分享除外)
 * 2.1 每次执行生成唯一activityId
 * 2.1 parentActivityId：该值为一级事件（停留时长）上报时activityId
 */
var MkReportSdk = /** @class */ (function () {
    function MkReportSdk(config) {
        // 进入页面事件的唯一id，会作为其他事件的parentActivityId
        this.firstActivityId = '';
        // 注册时的基本参数
        this.baseConfig = {
            version: 1,
            parentActivityId: '',
            platform: 'QW',
            isLog: false
        };
        // 上报时的参数
        this.reportConfig = null;
        // 循环上报
        this.loopParams = {
            loopTimer: null,
            stayTime: 0
        };
        this.baseConfig = __assign(__assign({}, this.baseConfig), config);
        this.firstActivityId = $uuid();
        this.handleClearLoopReport();
    }
    // 必须使用getInstance方法创建对象
    MkReportSdk.getInstance = function (config) {
        if (config === void 0) { config = {}; }
        MkReportSdk.install = new MkReportSdk(config);
        return MkReportSdk.install;
    };
    ;
    ;
    // 获取activityId
    MkReportSdk.prototype.getActivityId = function (event) {
        if (event === 'mkFullLinkStayTime') {
            // 如果是进入页面事件
            if (!this.firstActivityId)
                this.firstActivityId = $uuid();
            return this.firstActivityId;
        }
        return $uuid();
    };
    // 获取parentActivityId
    MkReportSdk.prototype.getParentActivityId = function (event) {
        var parentActivityId = this.baseConfig.parentActivityId;
        if (event === 'mkFullLinkStayTime') {
            // 如果是停留事件，则直接取链接上的parentActivityId
            return parentActivityId;
        }
        // 如果不是停留事件，则所有parentActivityId均为停留事件的activityId
        return this.firstActivityId;
    };
    // 获取时间
    MkReportSdk.prototype.getReportTime = function () {
        return new Date().getTime();
    };
    MkReportSdk.prototype.getCommonParams = function (event, reportParams) {
        var _a = this.baseConfig, version = _a.version, platform = _a.platform;
        var commonParams = JSON.parse(JSON.stringify(reportParams));
        if (event) {
            commonParams.event = event;
        }
        commonParams.activityId = reportParams.activityId || this.getActivityId(commonParams.event);
        commonParams.parentActivityId = reportParams.parentActivityId || this.getParentActivityId(commonParams.event);
        commonParams.reportTime = this.getReportTime();
        commonParams.version = version;
        commonParams.attr.platform = commonParams.attr.platform || platform || 'QW';
        return commonParams;
    };
    // 清空定时器
    MkReportSdk.prototype.handleClearLoopReport = function () {
        if (this.loopParams.loopTimer) {
            clearTimeout(this.loopParams.loopTimer);
            this.loopParams.loopTimer = null;
        }
    };
    // 请求接口上报
    MkReportSdk.prototype.reqReport = function (params, isNeedReport, async) {
        if (isNeedReport === void 0) { isNeedReport = true; }
        if (async === void 0) { async = true; }
        return __awaiter(this, void 0, void 0, function () {
            var request;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.baseConfig.request;
                        if (!isNeedReport) return [3 /*break*/, 4];
                        console.log("%c上报参数:", "background-color: #3370ff; padding: 7px; color: #fff;", JSON.stringify(params));
                        if (!request) return [3 /*break*/, 2];
                        return [4 /*yield*/, request(params)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, (0, jssdk_http_1.$jsdkHttp)({
                            method: 'post',
                            url: '/crm-trail-api/behaviors/qw',
                            params: params,
                            async: async
                        })];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // 进入页面
    MkReportSdk.prototype.triggerEvent = function (event, reportParams, isReport, async) {
        if (isReport === void 0) { isReport = true; }
        if (async === void 0) { async = true; }
        return __awaiter(this, void 0, void 0, function () {
            var commonParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isReport)
                            return [2 /*return*/];
                        commonParams = this.getCommonParams(event, reportParams);
                        return [4 /*yield*/, this.reqReport(commonParams, isReport, async)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    // 每5秒循环上报
    MkReportSdk.prototype.loopReport = function (reportParams, isReport) {
        var _this = this;
        if (isReport === void 0) { isReport = true; }
        this.handleClearLoopReport();
        if (!isReport)
            return;
        this.loopParams.loopTimer = setTimeout(function () {
            _this.loopParams.stayTime += 5;
            _this.mkFullLinkStayTime(reportParams);
            if (_this.loopParams.stayTime === 20) {
                _this.mkFullLinkStay(reportParams);
            }
            if (_this.loopParams.loopTimer) {
                _this.loopReport(reportParams);
            }
        }, 5000);
    };
    /**
     * 抽奖上报，基于 loopReport 方法改造，去除了 mkFullLinkStay 上报
     * @param reportParams
     * @param isReport
     * @returns
     */
    MkReportSdk.prototype.lotteryLoopReport = function (reportParams, isReport) {
        var _this = this;
        if (isReport === void 0) { isReport = true; }
        this.handleClearLoopReport();
        if (!isReport)
            return;
        this.loopParams.loopTimer = setTimeout(function () {
            _this.loopParams.stayTime += 5;
            _this.mkFullLinkStayTime(reportParams);
            if (_this.loopParams.loopTimer) {
                _this.lotteryLoopReport(reportParams);
            }
        }, 5000);
    };
    MkReportSdk.prototype.init = function (reportParams, isReport) {
        if (isReport === void 0) { isReport = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!isReport)
                            return [2 /*return*/];
                        this.loopParams.stayTime = 0;
                        // this.firstActivityId = $uuid()
                        this.handleClearLoopReport();
                        return [4 /*yield*/, this.mkFullLinkStayTime(reportParams)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.triggerEvent('mkFullLinkVisitPage', reportParams, isReport)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // 超过N（20）秒
    MkReportSdk.prototype.mkFullLinkStay = function (reportParams) {
        return __awaiter(this, void 0, void 0, function () {
            var mkFullLinkStayParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mkFullLinkStayParams = this.getCommonParams('mkFullLinkStay', reportParams);
                        mkFullLinkStayParams.attr.stayTime = 20;
                        return [4 /*yield*/, this.reqReport(mkFullLinkStayParams)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    // 停留时长
    MkReportSdk.prototype.mkFullLinkStayTime = function (reportParams) {
        return __awaiter(this, void 0, void 0, function () {
            var mkFullLinkStayTimeParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mkFullLinkStayTimeParams = this.getCommonParams('mkFullLinkStayTime', reportParams);
                        mkFullLinkStayTimeParams.attr.stayTime = this.loopParams.stayTime;
                        return [4 /*yield*/, this.reqReport(mkFullLinkStayTimeParams)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    // 手机号上报
    MkReportSdk.prototype.mkFullLinkGrant = function (reportParams) {
        return __awaiter(this, void 0, void 0, function () {
            var mkFullLinkStayParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mkFullLinkStayParams = this.getCommonParams('mkFullLinkGrant', reportParams);
                        return [4 /*yield*/, this.reqReport(mkFullLinkStayParams)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    // cms分享上报 - 添加触达模型
    MkReportSdk.prototype.mkAddCollection = function (params, webGateway, extra) {
        return __awaiter(this, void 0, void 0, function () {
            var request, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        request = this.baseConfig.request;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        if (!request) return [3 /*break*/, 3];
                        // 小程序需要传入
                        return [4 /*yield*/, request(params)];
                    case 2:
                        // 小程序需要传入
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, webGateway({
                            optionName: 'mk-material-center.mkmaterialcenter.CollectionService.AddCollection',
                            params: params,
                            extra: __assign(__assign({ application_name: 'mk-material-center', service_name: 'CollectionService', method_name: 'AddCollection', protobuf_version: 'v1.0.20230331182548462', res_type_name: 'AddCollectionResponse' }, extra), { header: __assign(__assign({}, extra === null || extra === void 0 ? void 0 : extra.header), { 'x-api-version': 'v1.0.20230331182548462' }) }),
                        })];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ;
    return MkReportSdk;
}());
exports.default = (function (config) {
    if (config === void 0) { config = {}; }
    return MkReportSdk.getInstance(config);
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGtEQUEwQjtBQUUxQixVQUFVO0FBQ1YsZ0RBQThDO0FBSzlDLElBQU0sS0FBSyxHQUFHLGNBQU0sT0FBQSxnQkFBSSxDQUFDLFFBQVEsRUFBRSxFQUFmLENBQWUsQ0FBQztBQUVwQywwR0FBMEc7QUFDMUc7Ozs7R0FJRztBQUVIOzs7O0dBSUc7QUFFSDtJQThCRSxxQkFBWSxNQUFrQjtRQXJCOUIsdUNBQXVDO1FBQ3ZDLG9CQUFlLEdBQUcsRUFBRSxDQUFBO1FBRXBCLFdBQVc7UUFDWCxlQUFVLEdBQWU7WUFDdkIsT0FBTyxFQUFFLENBQUM7WUFDVixnQkFBZ0IsRUFBRSxFQUFFO1lBQ3BCLFFBQVEsRUFBRSxJQUFJO1lBQ2QsS0FBSyxFQUFFLEtBQUs7U0FDYixDQUFDO1FBRUYsU0FBUztRQUNULGlCQUFZLEdBQTRCLElBQUksQ0FBQTtRQUU1QyxPQUFPO1FBQ1AsZUFBVSxHQUFHO1lBQ1gsU0FBUyxFQUFFLElBQVc7WUFDdEIsUUFBUSxFQUFFLENBQUM7U0FDWixDQUFBO1FBSUMsSUFBSSxDQUFDLFVBQVUseUJBQ1YsSUFBSSxDQUFDLFVBQVUsR0FDZixNQUFNLENBQ1YsQ0FBQztRQUNGLElBQUksQ0FBQyxlQUFlLEdBQUcsS0FBSyxFQUFFLENBQUE7UUFDOUIsSUFBSSxDQUFDLHFCQUFxQixFQUFFLENBQUE7SUFDOUIsQ0FBQztJQWxDRCx3QkFBd0I7SUFDakIsdUJBQVcsR0FBbEIsVUFBbUIsTUFBdUI7UUFBdkIsdUJBQUEsRUFBQSxXQUF1QjtRQUN4QyxXQUFXLENBQUMsT0FBTyxHQUFHLElBQUksV0FBVyxDQUFDLE1BQU0sQ0FBQyxDQUFDO1FBQzlDLE9BQU8sV0FBVyxDQUFDLE9BQU8sQ0FBQztJQUM3QixDQUFDO0lBQUEsQ0FBQztJQThCRCxDQUFDO0lBRUYsZUFBZTtJQUNmLG1DQUFhLEdBQWIsVUFBYyxLQUFnQjtRQUM1QixJQUFJLEtBQUssS0FBSyxvQkFBb0IsRUFBRTtZQUNsQyxZQUFZO1lBQ1osSUFBSSxDQUFDLElBQUksQ0FBQyxlQUFlO2dCQUFFLElBQUksQ0FBQyxlQUFlLEdBQUcsS0FBSyxFQUFFLENBQUE7WUFDekQsT0FBTyxJQUFJLENBQUMsZUFBZSxDQUFBO1NBQzVCO1FBQ0QsT0FBTyxLQUFLLEVBQUUsQ0FBQTtJQUNoQixDQUFDO0lBRUQscUJBQXFCO0lBQ3JCLHlDQUFtQixHQUFuQixVQUFvQixLQUFnQjtRQUMxQixJQUFBLGdCQUFnQixHQUFLLElBQUksQ0FBQyxVQUFVLGlCQUFwQixDQUFxQjtRQUM3QyxJQUFJLEtBQUssS0FBSyxvQkFBb0IsRUFBRTtZQUNsQyxtQ0FBbUM7WUFDbkMsT0FBTyxnQkFBZ0IsQ0FBQTtTQUN4QjtRQUNELGdEQUFnRDtRQUNoRCxPQUFPLElBQUksQ0FBQyxlQUFlLENBQUE7SUFDN0IsQ0FBQztJQUVELE9BQU87SUFDUCxtQ0FBYSxHQUFiO1FBQ0UsT0FBTyxJQUFJLElBQUksRUFBRSxDQUFDLE9BQU8sRUFBRSxDQUFBO0lBQzdCLENBQUM7SUFFRCxxQ0FBZSxHQUFmLFVBQWdCLEtBQTRCLEVBQUUsWUFBOEI7UUFDcEUsSUFBQSxLQUF3QixJQUFJLENBQUMsVUFBVSxFQUFyQyxPQUFPLGFBQUEsRUFBRSxRQUFRLGNBQW9CLENBQUM7UUFDOUMsSUFBTSxZQUFZLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFDLFlBQVksQ0FBQyxDQUFDLENBQUE7UUFDNUQsSUFBSSxLQUFLLEVBQUU7WUFDVixZQUFZLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQTtTQUMzQjtRQUNELFlBQVksQ0FBQyxVQUFVLEdBQUcsWUFBWSxDQUFDLFVBQVUsSUFBSSxJQUFJLENBQUMsYUFBYSxDQUFDLFlBQVksQ0FBQyxLQUFLLENBQUMsQ0FBQTtRQUMzRixZQUFZLENBQUMsZ0JBQWdCLEdBQUcsWUFBWSxDQUFDLGdCQUFnQixJQUFJLElBQUksQ0FBQyxtQkFBbUIsQ0FBQyxZQUFZLENBQUMsS0FBSyxDQUFDLENBQUE7UUFDN0csWUFBWSxDQUFDLFVBQVUsR0FBRyxJQUFJLENBQUMsYUFBYSxFQUFFLENBQUE7UUFDOUMsWUFBWSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUE7UUFDOUIsWUFBWSxDQUFDLElBQUksQ0FBQyxRQUFRLEdBQUcsWUFBWSxDQUFDLElBQUksQ0FBQyxRQUFRLElBQUksUUFBUSxJQUFJLElBQUksQ0FBQTtRQUMzRSxPQUFPLFlBQVksQ0FBQTtJQUNyQixDQUFDO0lBRUQsUUFBUTtJQUNSLDJDQUFxQixHQUFyQjtRQUNFLElBQUksSUFBSSxDQUFDLFVBQVUsQ0FBQyxTQUFTLEVBQUU7WUFDN0IsWUFBWSxDQUFDLElBQUksQ0FBQyxVQUFVLENBQUMsU0FBUyxDQUFDLENBQUE7WUFDdkMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxTQUFTLEdBQUcsSUFBSSxDQUFBO1NBQ2pDO0lBQ0gsQ0FBQztJQUVELFNBQVM7SUFDSCwrQkFBUyxHQUFmLFVBQWdCLE1BQXdCLEVBQUUsWUFBbUIsRUFBRSxLQUFZO1FBQWpDLDZCQUFBLEVBQUEsbUJBQW1CO1FBQUUsc0JBQUEsRUFBQSxZQUFZOzs7Ozs7d0JBQ2pFLE9BQU8sR0FBSyxJQUFJLENBQUMsVUFBVSxRQUFwQixDQUFxQjs2QkFDaEMsWUFBWSxFQUFaLHdCQUFZO3dCQUNkLE9BQU8sQ0FBQyxHQUFHLENBQUMsU0FBUyxFQUFFLHVEQUF1RCxFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQzs2QkFDcEcsT0FBTyxFQUFQLHdCQUFPO3dCQUNULHFCQUFNLE9BQU8sQ0FBQyxNQUFNLENBQUMsRUFBQTs7d0JBQXJCLFNBQXFCLENBQUE7OzRCQUVyQixxQkFBTSxJQUFBLHNCQUFTLEVBQUM7NEJBQ2QsTUFBTSxFQUFFLE1BQU07NEJBQ2QsR0FBRyxFQUFFLDZCQUE2Qjs0QkFDbEMsTUFBTSxRQUFBOzRCQUNOLEtBQUssT0FBQTt5QkFDTixDQUFDLEVBQUE7O3dCQUxGLFNBS0UsQ0FBQTs7Ozs7O0tBR1A7SUFFRCxPQUFPO0lBQ0Qsa0NBQVksR0FBbEIsVUFBbUIsS0FBZ0IsRUFBRSxZQUE4QixFQUFFLFFBQWUsRUFBRSxLQUFZO1FBQTdCLHlCQUFBLEVBQUEsZUFBZTtRQUFFLHNCQUFBLEVBQUEsWUFBWTs7Ozs7O3dCQUNoRyxJQUFJLENBQUMsUUFBUTs0QkFBRSxzQkFBTTt3QkFDZixZQUFZLEdBQUcsSUFBSSxDQUFDLGVBQWUsQ0FBQyxLQUFLLEVBQUUsWUFBWSxDQUFDLENBQUE7d0JBQzlELHFCQUFNLElBQUksQ0FBQyxTQUFTLENBQUMsWUFBWSxFQUFFLFFBQVEsRUFBRSxLQUFLLENBQUMsRUFBQTs7d0JBQW5ELFNBQW1ELENBQUE7Ozs7O0tBQ3BEO0lBQUEsQ0FBQztJQUVGLFVBQVU7SUFDVixnQ0FBVSxHQUFWLFVBQVcsWUFBOEIsRUFBRSxRQUFlO1FBQTFELGlCQWFDO1FBYjBDLHlCQUFBLEVBQUEsZUFBZTtRQUN4RCxJQUFJLENBQUMscUJBQXFCLEVBQUUsQ0FBQTtRQUM1QixJQUFJLENBQUMsUUFBUTtZQUFFLE9BQU07UUFDckIsSUFBSSxDQUFDLFVBQVUsQ0FBQyxTQUFTLEdBQUcsVUFBVSxDQUFDO1lBQ3JDLEtBQUksQ0FBQyxVQUFVLENBQUMsUUFBUSxJQUFJLENBQUMsQ0FBQTtZQUM3QixLQUFJLENBQUMsa0JBQWtCLENBQUMsWUFBWSxDQUFDLENBQUE7WUFDckMsSUFBSSxLQUFJLENBQUMsVUFBVSxDQUFDLFFBQVEsS0FBSyxFQUFFLEVBQUU7Z0JBQ25DLEtBQUksQ0FBQyxjQUFjLENBQUMsWUFBWSxDQUFDLENBQUE7YUFDbEM7WUFDRCxJQUFJLEtBQUksQ0FBQyxVQUFVLENBQUMsU0FBUyxFQUFFO2dCQUM3QixLQUFJLENBQUMsVUFBVSxDQUFDLFlBQVksQ0FBQyxDQUFBO2FBQzlCO1FBQ0gsQ0FBQyxFQUFFLElBQUksQ0FBQyxDQUFDO0lBQ1gsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0gsdUNBQWlCLEdBQWpCLFVBQWtCLFlBQThCLEVBQUUsUUFBZTtRQUFqRSxpQkFVQztRQVZpRCx5QkFBQSxFQUFBLGVBQWU7UUFDL0QsSUFBSSxDQUFDLHFCQUFxQixFQUFFLENBQUE7UUFDNUIsSUFBSSxDQUFDLFFBQVE7WUFBRSxPQUFNO1FBQ3JCLElBQUksQ0FBQyxVQUFVLENBQUMsU0FBUyxHQUFHLFVBQVUsQ0FBQztZQUNyQyxLQUFJLENBQUMsVUFBVSxDQUFDLFFBQVEsSUFBSSxDQUFDLENBQUE7WUFDN0IsS0FBSSxDQUFDLGtCQUFrQixDQUFDLFlBQVksQ0FBQyxDQUFBO1lBQ3JDLElBQUksS0FBSSxDQUFDLFVBQVUsQ0FBQyxTQUFTLEVBQUU7Z0JBQzdCLEtBQUksQ0FBQyxpQkFBaUIsQ0FBQyxZQUFZLENBQUMsQ0FBQTthQUNyQztRQUNILENBQUMsRUFBRSxJQUFJLENBQUMsQ0FBQztJQUNYLENBQUM7SUFFSywwQkFBSSxHQUFWLFVBQVcsWUFBOEIsRUFBRSxRQUFlO1FBQWYseUJBQUEsRUFBQSxlQUFlOzs7Ozt3QkFDeEQsSUFBSSxDQUFDLFFBQVE7NEJBQUUsc0JBQU07d0JBQ3JCLElBQUksQ0FBQyxVQUFVLENBQUMsUUFBUSxHQUFHLENBQUMsQ0FBQTt3QkFDNUIsaUNBQWlDO3dCQUNqQyxJQUFJLENBQUMscUJBQXFCLEVBQUUsQ0FBQTt3QkFDNUIscUJBQU0sSUFBSSxDQUFDLGtCQUFrQixDQUFDLFlBQVksQ0FBQyxFQUFBOzt3QkFBM0MsU0FBMkMsQ0FBQTt3QkFDM0MscUJBQU0sSUFBSSxDQUFDLFlBQVksQ0FBQyxxQkFBcUIsRUFBRSxZQUFZLEVBQUUsUUFBUSxDQUFDLEVBQUE7O3dCQUF0RSxTQUFzRSxDQUFBOzs7OztLQUN2RTtJQUVELFdBQVc7SUFDTCxvQ0FBYyxHQUFwQixVQUFxQixZQUE4Qjs7Ozs7O3dCQUMzQyxvQkFBb0IsR0FBRyxJQUFJLENBQUMsZUFBZSxDQUFDLGdCQUFnQixFQUFFLFlBQVksQ0FBQyxDQUFBO3dCQUNqRixvQkFBb0IsQ0FBQyxJQUFJLENBQUMsUUFBUSxHQUFHLEVBQUUsQ0FBQTt3QkFDdkMscUJBQU0sSUFBSSxDQUFDLFNBQVMsQ0FBQyxvQkFBb0IsQ0FBQyxFQUFBOzt3QkFBMUMsU0FBMEMsQ0FBQTs7Ozs7S0FDM0M7SUFBQSxDQUFDO0lBRUYsT0FBTztJQUNELHdDQUFrQixHQUF4QixVQUF5QixZQUE4Qjs7Ozs7O3dCQUMvQyx3QkFBd0IsR0FBRyxJQUFJLENBQUMsZUFBZSxDQUFDLG9CQUFvQixFQUFFLFlBQVksQ0FBQyxDQUFBO3dCQUN6Rix3QkFBd0IsQ0FBQyxJQUFJLENBQUMsUUFBUSxHQUFHLElBQUksQ0FBQyxVQUFVLENBQUMsUUFBUSxDQUFBO3dCQUNqRSxxQkFBTSxJQUFJLENBQUMsU0FBUyxDQUFDLHdCQUF3QixDQUFDLEVBQUE7O3dCQUE5QyxTQUE4QyxDQUFBOzs7OztLQUMvQztJQUFBLENBQUM7SUFFRixRQUFRO0lBQ0YscUNBQWUsR0FBckIsVUFBc0IsWUFBOEI7Ozs7Ozt3QkFDNUMsb0JBQW9CLEdBQUcsSUFBSSxDQUFDLGVBQWUsQ0FBQyxpQkFBaUIsRUFBRSxZQUFZLENBQUMsQ0FBQTt3QkFDbEYscUJBQU0sSUFBSSxDQUFDLFNBQVMsQ0FBQyxvQkFBb0IsQ0FBQyxFQUFBOzt3QkFBMUMsU0FBMEMsQ0FBQTs7Ozs7S0FDM0M7SUFBQSxDQUFDO0lBRUYsbUJBQW1CO0lBQ2IscUNBQWUsR0FBckIsVUFBc0IsTUFBVyxFQUFFLFVBQWUsRUFBRSxLQUFXOzs7Ozs7d0JBQ3JELE9BQU8sR0FBSyxJQUFJLENBQUMsVUFBVSxRQUFwQixDQUFxQjs7Ozs2QkFFOUIsT0FBTyxFQUFQLHdCQUFPO3dCQUNULFVBQVU7d0JBQ1YscUJBQU0sT0FBTyxDQUFDLE1BQU0sQ0FBQyxFQUFBOzt3QkFEckIsVUFBVTt3QkFDVixTQUFxQixDQUFBOzs0QkFFckIscUJBQU0sVUFBVSxDQUFDOzRCQUNmLFVBQVUsRUFBRSxxRUFBcUU7NEJBQ2pGLE1BQU0sRUFBRSxNQUFNOzRCQUNkLEtBQUssc0JBQ0gsZ0JBQWdCLEVBQUUsb0JBQW9CLEVBQ3RDLFlBQVksRUFBRSxtQkFBbUIsRUFDakMsV0FBVyxFQUFFLGVBQWUsRUFDNUIsZ0JBQWdCLEVBQUUsd0JBQXdCLEVBQzFDLGFBQWEsRUFBRSx1QkFBdUIsSUFDbkMsS0FBSyxLQUNSLE1BQU0sd0JBQ0QsS0FBSyxhQUFMLEtBQUssdUJBQUwsS0FBSyxDQUFFLE1BQU0sS0FDaEIsZUFBZSxFQUFFLHdCQUF3QixNQUU1Qzt5QkFDRixDQUFDLEVBQUE7O3dCQWZGLFNBZUUsQ0FBQTs7Ozs7Ozs7OztLQUtQO0lBQUEsQ0FBQztJQUNKLGtCQUFDO0FBQUQsQ0FBQyxBQTVNRCxJQTRNQztBQUVELG1CQUFlLFVBQUMsTUFBdUI7SUFBdkIsdUJBQUEsRUFBQSxXQUF1QjtJQUFLLE9BQUEsV0FBVyxDQUFDLFdBQVcsQ0FBQyxNQUFNLENBQUM7QUFBL0IsQ0FBK0IsRUFBQyJ9